import { render, staticRenderFns } from "./approvalReport.vue?vue&type=template&id=479a2122"
import script from "./approvalReport.vue?vue&type=script&lang=js"
export * from "./approvalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports